import { Form, Input } from 'antd';
import CompanyCreationFormContext from '../../../contexts/data/companies/CompanyCreationFormContext';
import React, { useContext, useMemo } from 'react';
import { isValidEmail } from '@leedpulse-monorepo/utils';


export default function EmailFormItem() {
    const formContext = useContext(CompanyCreationFormContext);

    // Only rendered when createNewUser is true, but the context type is a union
    const email = formContext.user.createNewUser ? formContext.user.email : '';

    const trimmedEmail = useMemo(() => email.trim(), [email]);
    const showError = useMemo(() => trimmedEmail.length > 0 && !isValidEmail(trimmedEmail), [trimmedEmail]);

    return (
        <Form.Item label="Adresse email" layout="vertical" validateStatus={showError ? 'error' : undefined} help={showError ? 'Format d\'email invalide' : undefined}>
            <Input
                value={email}
                onChange={(e) => formContext.onEmailChange(e.target.value)}
                placeholder="jean.dupont@email.com"
                autoFocus
            />
        </Form.Item>
    );
}